import { render } from "./DVDorMovie.vue?vue&type=template&id=4cd6c822&scoped=true"
import script from "./DVDorMovie.vue?vue&type=script&setup=true&lang=js"
export * from "./DVDorMovie.vue?vue&type=script&setup=true&lang=js"

import "./DVDorMovie.vue?vue&type=style&index=0&id=4cd6c822&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cd6c822"],['__file',"src/components/course/DVDorMovie.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4cd6c822"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4cd6c822', __exports__)) {
    api.reload('4cd6c822', __exports__)
  }
  
  module.hot.accept("./DVDorMovie.vue?vue&type=template&id=4cd6c822&scoped=true", () => {
    api.rerender('4cd6c822', render)
  })

}


export default __exports__